import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../Redux/hooks/useAuth'
import { ToastContainer } from 'react-toastify';

import '../assets/css/panel-style.css'
import '../assets/css/panel-modern.css'
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from '../Sections/panel/Sidebar';
import Header from '../Sections/panel/Header';
import MetaTags from '../Components/MetaTags';

export function PrivateOutlet() {
  const auth = useAuth()
  const location = useLocation()
  

  return auth.user ? (
    <>
      {location.pathname.includes("/exam/",6) ? 
          <>
            <Outlet />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
          </>
      :
      <>
      <MetaTags
          siteName="سایت مرجع آزمون GRE"
          title="ناحیه کاربری | سایت مرجع آزمون GRE"
          description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
          url="https://grehub.org/panel"
          image="https://grehub.org/GREhub_LOGO.jpg"
          ogType="website"
          twitterCard="summary_large_image"
      />
      <div className="panel-shell">
        <Header />
        <div className="container-fluid panel-container">
          <div className="row g-3 align-items-start">
            <Sidebar />
            <Outlet />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
          </div>
        </div>
      </div>
      </>}
    </>
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  )
}
